import { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '../colors-v2';
import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';
import { BlogCommonAuthor } from './BlogCommonAuthor';

const Main = styled.div.withConfig({
  componentId: 'BlogHeader_Main',
} as any)`
  .dol-breadcrumb {
    margin-bottom: 20px;
  }

  > .title {
    margin-bottom: 16px;

    h1 {
      margin-bottom: 0;
    }
  }

  > .description {
    color: ${colorsV2.black70};
    margin-bottom: 16px;
  }
`;

export interface BlogPostAuthor {
  name?: string;
  avatarUrl?: string;
  authorAboutURL?: string;
  testimonialText?: string | React.ReactNode;
}

export interface BlogHeaderProps {
  socials: JSX.Element | React.ReactNode;
  routes: Route[];
  breadcrumb?: JSX.Element | React.ReactNode;
  title?: string;
  description?: string;
  readTimeInMinutes: number | string;
  author: BlogPostAuthor;
  publishedDate: Date;
  headerEditor?: JSX.Element | React.ReactNode;

  seoData?: any;
}

export const BlogHeader = (props: BlogHeaderProps) => {
  const {
    headerEditor,
    socials,
    breadcrumb,
    title,
    description,
    readTimeInMinutes,
    author = {},
    publishedDate,
  } = props;
  const hasHeaderEditor = Boolean(headerEditor);

  return (
    <Main id="blog-header">
      {breadcrumb}
      {hasHeaderEditor ? (
        headerEditor
      ) : (
        <>
          <div className="title font-noto">
            <ResponsiveTypography.Title variant={['regular/32', 'regular/42', 'regular/42']}>
              {title}
            </ResponsiveTypography.Title>
          </div>
          {description && (
            <div className="description font-noto">
              <ResponsiveTypography.Paragraph variant="regular/20">
                {description}
              </ResponsiveTypography.Paragraph>
            </div>
          )}
        </>
      )}
      <BlogCommonAuthor
        socials={socials}
        readTimeInMinutes={readTimeInMinutes}
        publishedDate={publishedDate}
        author={author}
      />
    </Main>
  );
};
